import { render, staticRenderFns } from "./TrainingEcg.vue?vue&type=template&id=74c1cae8&"
import script from "./TrainingEcg.vue?vue&type=script&lang=js&"
export * from "./TrainingEcg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports